/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPeopleGroupCircle = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M7.5 9.711c0-.635.544-1.211 1.292-1.211.395 0 .74.165.975.417l1.466-1.36A3.323 3.323 0 0 0 8.792 6.5C7.008 6.5 5.5 7.904 5.5 9.711c0 1.084.55 2.032 1.37 2.607l1.15-1.636a1.185 1.185 0 0 1-.52-.97zM15.208 8.5c.748 0 1.292.576 1.292 1.211 0 .387-.194.742-.52.97l1.15 1.637a3.185 3.185 0 0 0 1.37-2.607c0-1.807-1.508-3.211-3.292-3.211-.962 0-1.836.405-2.441 1.057l1.466 1.36c.234-.252.58-.417.975-.417zM9 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm3-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
        <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zM4 12a8 8 0 1 1 14.633 4.474 3.948 3.948 0 0 0-.552-.934c-.673-.844-1.678-1.372-2.957-1.532l-.248 1.984c.852.107 1.347.426 1.641.795.28.352.452.842.48 1.461-.36.288-.745.546-1.152.77a4.194 4.194 0 0 0-.752-1.628C14.396 16.493 13.336 16 12 16s-2.396.493-3.093 1.39a4.194 4.194 0 0 0-.752 1.627 8.022 8.022 0 0 1-1.151-.769c.027-.62.198-1.109.479-1.46.294-.37.789-.69 1.641-.796l-.248-1.984c-1.279.16-2.284.688-2.957 1.532-.23.29-.413.604-.552.934A7.963 7.963 0 0 1 4 12zm6.047 7.76c.073-.489.229-.872.439-1.143.267-.344.708-.617 1.514-.617s1.247.273 1.514.617c.21.271.366.654.439 1.143-.625.157-1.28.24-1.953.24s-1.328-.083-1.953-.24z" />
      </g>
    </g>
  </Icon>
);
export { SvgPeopleGroupCircle as PeopleGroupCircle };
